import { IS_DEV_MODE } from '../../config';
import { useDispatch, useSelector } from 'react-redux';
import { getLiteTradeConfig } from '../../modules/LiteTrade/liteTradeSelectors';
import { getWebsocketChannels, getWebsocketReadyState } from '../WebSocketProvider/websocketSelectors';
import { websocketChannelClose } from '../WebSocketProvider/websocketReducer';

const LiteTradeWSConnector = () => {
    const dispatch = useDispatch();
    const liteTradeConfig = useSelector(getLiteTradeConfig);
    const readyStates = useSelector(getWebsocketReadyState());
    const readyState = readyStates[liteTradeConfig.wssUrl];
    const openChannels = useSelector(getWebsocketChannels);
    const reconnectHandler = () => {
        Object.keys(openChannels).forEach((channel) => {
            dispatch(websocketChannelClose({ channel }));
        });
    };
 
    return (
        <>
            {(IS_DEV_MODE || readyState === WebSocket.CLOSED) && (
                <div
                    style={{
                        position: 'absolute',
                        zIndex: 99999,
                        top: '4px',
                        right: '4px',
                        background: readyState === WebSocket.OPEN ? 'var(--color-green)' : 'var(--color-red)',
                        width: '8px',
                        height: '8px',
                        margin: '8px',
                        borderRadius: '4px',
                        // pointerEvents: 'none'
                    }}
                    onClick={reconnectHandler}
                />
            )}
        </>
    );
};

export default LiteTradeWSConnector;
